// modules
import Vue from "vue";
import Router from "vue-router";
import store from './store.js';
// views
import Home from "./views/Home.vue";
import Profile from "./views/Profile.vue";
import Items from "./views/Items.vue";
import AddItem from "./views/AddItem.vue";
import EditItem from "./views/EditItem.vue";
import Login from './views/Login';
import SignUp from './views/SignUp';
import ImportItems from './views/ImportItems';
import ExportItems from './views/ExportItems';
import History from './views/History';
import SuggestRecipes from './views/SuggestRecipes';
import itemBase from './views/itemBase';
import FAQ from './views/FAQ';
import Updates from './views/Updates';
import ExpressPreview from './views/ExpressPreview';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    };
  },
  routes: [
    {
      path: '/import-items',
      name: 'Import items',
      component: ImportItems,
      meta: { 
        title: "Импорт предметов",
        requiresAuth: true,
      },
    },
    {
      path: '/export-items',
      name: 'Export items',
      component: ExportItems,
      meta: {
        title: "Экспорт предметов",
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { 
        title: "Вход в аккаунт",
        requiresAuth: false,
      },
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp,
      meta: { 
        title: "Создание аккаунта",
        requiresAuth: false,
      },
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "Главная",
        requiresAuth: false,
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { 
        title: "Настройки",
        requiresAuth: true,
      },
    },
    {
      path: "/items",
      name: "items",
      component: Items,
      meta: { 
        title: "Коллекция предметов",
        requiresAuth: true,
      },
    },
    {
      path: "/add-item",
      name: "add item",
      component: AddItem,
      meta: { 
        title: "Добавить предмет",
        requiresAuth: true,
      },
    },
    {
      path: "/edit-item/:item",
      name: "edit item",
      component: EditItem,
      meta: { 
        title: "Редактировать предмет",
        requiresAuth: true,
      },
    },
    {
      path: "/history",
      name: "history",
      component: History,
      meta: { 
        title: "История",
        requiresAuth: true,
      },
    },
    {
      path: "/suggest-recipes",
      name: "suggest recipes",
      component: SuggestRecipes,
      meta: { 
        title: "Замена рецептов",
        requiresAuth: true,
      },
    },
    {
      path: "/item-base",
      name: "item base",
      component: itemBase,
      meta: { 
        title: "База предметов",
        requiresAuth: true,
      },
    },
    {
      path: "/faq",
      name: "faq",
      component: FAQ,
      meta: {
        title: "Руководства",
      requiresAuth: false,
      },
    },
    {
      path: "/updates",
      name: "updates",
      component: Updates,
      meta: {
        title: "Обновления",
        requiresAuth: false,
      },
    },
    {
      path: "/express-preview",
      name: "express preview",
      component: ExpressPreview,
      meta: {
        title: "Экспресс превью",
        requiresAuth: false,
      },
    },
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = (store.state.user != null) ? true : false;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // Vue.prevRoute = from;
  // console.log(from);
  // console.log(requiresAuth, !currentUser);
  if (requiresAuth && !currentUser) {
    // console.log(to);
    // next('login');
    // next({name: 'Login', params: {prevPage: to.name}});
    next({name: 'home', params: {prevPage: to.name}});
    // console.log('login');
    /*firebase.auth().signInAnonymously().then(function(){
      router.push({name: 'profile'});
    });*/
  } else if (!requiresAuth && currentUser) {
    next();
  } else {
    next();
  };

});

router.afterEach((to, from) => {
  // if (to.name == 'edit item') { 
  // this.prevRoute = from;
  if (to.name == 'edit item') {
    // console.log('router edit item');
    var history = store.state.history;
    // if (from.name == 'edit item') {
      // console.log(history);
    // } else {
      history.push({
        item: to.params.item,
      });
      store.commit('updateHistory', {history: history});
    // };
  };  
})

/*router.beforeRouteEnter((to, from, next) => {
  next(vm => {
    vm.prevRoute = from
  });
});*/

export default router;